import { gql } from '@apollo/client';

const RevenueChart = gql(/* GraphQL */ `
  query RevenueChart(
    $currency_id: String!
    $gate_group_id: String
    $operation_type: RevenueChartOperationType!
    $date_from: date!
    $date_to: date!
    $comparison_mode: DashboardV2ComparisonMode
    $group_by: DashboardV2GroupBy
  ) {
    dashboardWidgetsRevenueAnalyticsV2(
      currency_id: $currency_id
      gate_group_id: $gate_group_id
      operation_type: $operation_type
      date_from: $date_from
      date_to: $date_to
      comparison_mode: $comparison_mode
      group_by: $group_by
    ) {
      summary {
        revenue {
          current_total
          previous_total
          diff_percent
          comparison_period_label
        }
        average_bill {
          current_total
          previous_total
          diff_percent
          comparison_period_label
        }
        amount {
          current_total
          previous_total
          diff_percent
          comparison_period_label
        }
        refund {
          current_total
          previous_total
          diff_percent
          comparison_period_label
        }
      }
      chart_data {
        step_index
        current_period {
          date
          revenue
          amount
          average_bill
          refund
        }
        previous_period {
          date
          revenue
          amount
          average_bill
          refund
        }
      }
    }
  }
`);

export default RevenueChart;
